import analysisModule from "../analysisModule"

analysisModule.service("nodeCommandResolveOrderBreak", ["orderBreakModal", (orderBreakModal) => {
    return (selection) => {
        return orderBreakModal(selection)
    }
}])
